module.exports = __webpack_public_path__ + "static/assets/c2420610470e2fa362d22e6aaf63ae7e.svg";